import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import En from './components/en';
import Fr from './components/fr';
import Header from './components/header';
import './App.css';

function App() {
  return (
    <Router>
      <Header />
      <div className="App">
        <Routes>
          <Route path="/en" element={<En />} />
          <Route path="/" element={<Fr />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
